// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2Zqx4","container":"styles_container__3uYK-","title":"styles_title__19CK4","wrapper":"styles_wrapper__1Sr-e","answer":"styles_answer__2PFBj"};